<section class="fullWidthCls admPageSec marginAtTop">
  <div class="container-fluid">
    <div class="row">
      <div class="admPageTitleSec">
        <p class="admPageTitle">
        <i class="material-icons cusIconSize">&#xE897;</i>
        <span>Concurrent Exams</span>
        </p>
      </div>
      <div *ngFor="let capacityGroup of capacityGroups">
        <div *ngIf="capacityGroup.isDefault(); else examTypeGroup">
          <md-card>
            <md-card-header>
              <div class="admPageHeadingSec">
                <md-card-title>
                  <div class="admPageHeading">
                    <p><span>Default Concurrency</span></p>
                  </div>
                </md-card-title>
              </div>
            </md-card-header>
            <md-card-content>
              <div class="col s12 m12 l12">
                <ul class="capacity-config-settings">
                  <li class="row">
                    <div class="col s2 m2 l2">
                      <div class="errorZoneSec">
                        <label>Exam Type</label>
                      </div>
                    </div>
                    <div class="col s2 m2 l2">
                      <div class="errorZoneSec">
                        <label>Capacity</label>
                      </div>
                    </div>
                  </li>
                  <li class="row" *ngFor="let formGroup of capacityGroup.formGroups">
                    <form [formGroup]="formGroup">
                      <div class="col s2 m2 l2">
                        <div class="errorZoneSec">
                          <span>{{capacityGroup.getExamTypeDisplay(formGroup)}}</span>
                        </div>
                      </div>
                      <div class="col s2 m2 l2">
                        <div class="errorZoneSec">
                          <input type="number" class="capacityInput" mdInput min="1" formControlName="capacity">
                          <p requiredField *ngIf="formGroup.controls.capacity.invalid && formGroup.controls.capacity.errors && fromGroup.controls.capacity.errors.required"></p>
                        </div>
                      </div>
                    </form>
                  </li>
                </ul>
              </div>
              <div class="col s12 m12 l12">
                <div *ngIf="capacityGroup.formsInvalid && capacityGroup.formsError" class="errorZoneSec">
                  <p class="validate">{{capacityGroup.formsError}}</p>
                </div>
                <div class="button-row">
                  <button [disabled]="capacityGroup.formsInvalid || capacityGroup.updateBtnDisabled" md-raised-button class="glbAdminBtnCls1" (click)="capacityGroup.onUpdate()">
                    <img src="./assets/images/saveBtnIcon.png" alt="">UPDATE</button>
                  <button [disabled]="capacityGroup.editBtnDisabled" md-raised-button class="glbAdminBtnCls1" (click)="capacityGroup.onEdit()">
                    <img src="./assets/images/editBtnIcon.png" alt="">EDIT</button>
                </div>
              </div>
            </md-card-content>
          </md-card>
          <md-card class="admAdditionalCard">
            <md-card-header>
              <div class="admPageHeadingSec">
                <md-card-title>
                  <div class="admPageHeading">
                    <p><span>Time Zone (Defaults to UTC)</span></p>
                  </div>
                </md-card-title>
              </div>
            </md-card-header>
            <md-card-content>
              <div class="col s12 m12 l12">
                <form [formGroup]="scheduleTimeZoneForm">
                  <div class="col s12 m3 l3">
                    <md-form-field>
                      <input class="capacityTimeZoneInput" type="text" placeholder="Time Zone" mdInput formControlName="timeZoneControl" [mdAutocomplete]="timeZone" [showDropDown]="{model: 'timeZone', scope: this, formAttr: 'scheduleTimeZoneForm'}">
                      <md-autocomplete #timeZone="mdAutocomplete" [displayWith]="_utility.displayFn">
                        <md-option *ngFor="let option of timeZoneFilteredOptions | async" [value]="option">
                          {{ option.name }}
                        </md-option>
                      </md-autocomplete>
                    </md-form-field>
                  </div>
                  <div class="col s12 m12 l12">
                    <div class="button-row">
                      <button md-raised-button class="glbAdminBtnCls1" (click)="onUpdateTimeZone()">UPDATE</button>
                    </div>
                  </div>
                  <div class="col s12 m12 l12">
                    <p style="margin: 1em 0;">(Click to manage the schedules using the specified time zone. Unsaved changes to the schedule will be lost.)</p>
                  </div>
                </form>
              </div>
            </md-card-content>
          </md-card>
        </div>
        <ng-template #examTypeGroup>
          <md-card class="admAdditionalCard">
            <md-card-header>
              <div class="admPageHeadingSec">
                <md-card-title>
                  <div class="admPageHeading">
                    <p><span>{{capacityGroup.getExamTypeDisplay()}}</span></p>
                  </div>
                </md-card-title>
              </div>
            </md-card-header>
            <md-card-content>
              <div class="col s12 m12 l12">
                <ul class="capacity-config-settings">
                  <li class="row">
                    <div class="col s2 m2 l2">
                      <div class="errorZoneSec">
                        <label>Start Time ({{timeZoneToEditIn}})</label>
                      </div>
                    </div>
                    <div class="col s2 m2 l2">
                      <div class="errorZoneSec">
                        <label>End Time ({{timeZoneToEditIn}})</label>
                      </div>
                    </div>
                    <div class="col s2 m2 l2">
                      <div class="errorZoneSec">
                        <label>Start Date</label>
                      </div>
                    </div>
                    <div class="col s2 m2 l2">
                      <div class="errorZoneSec">
                        <label>End Date</label>
                      </div>
                    </div>
                    <div class="col s2 m2 l2">
                      <div class="errorZoneSec">
                        <label>Capacity</label>
                      </div>
                    </div>
                    <div class="col s2 m2 l2">
                      <div class="errorZoneSec">
                        <label>Actions</label>
                      </div>
                    </div>
                  </li>
                  <li class="row" *ngFor="let formGroup of capacityGroup.formGroups">
                    <form [formGroup]="formGroup">
                      <div class="col s2 m2 l2">
                        <div class="errorZoneSec">
                          <md-select class="capacityInput" formControlName="startTime">
                            <md-option *ngFor="let option of capacityTimes" [value]="option">
                              {{ option }}
                            </md-option>
                          </md-select>
                          <p requiredField *ngIf="formGroup.controls.startTime.invalid && formGroup.controls.startTime.errors && formGroup.controls.startTime.errors.required"></p>
                        </div>
                      </div>
                      <div class="col s2 m2 l2">
                        <div class="errorZoneSec">
                          <md-select class="capacityInput" formControlName="endTime">
                            <md-option *ngFor="let option of capacityTimes" [value]="option">
                              {{ option }}
                            </md-option>
                          </md-select>
                          <p requiredField *ngIf="formGroup.controls.endTime.invalid && formGroup.controls.endTime.errors && formGroup.controls.endTime.errors.required"></p>
                        </div>
                      </div>
                      <div class="col s2 m2 l2">
                        <div class="errorZoneSec">
                          <input mdInput type="date" class="capacityInput" formControlName="startDate">
                        </div>
                      </div>
                      <div class="col s2 m2 l2">
                        <div class="errorZoneSec">
                          <input mdInput type="date" class="capacityInput" formControlName="endDate">
                        </div>
                      </div>
                      <div class="col s2 m2 l2">
                        <div class="errorZoneSec">
                          <input type="number" class="capacityInput" mdInput min="1" formControlName="capacity">
                          <p requiredField *ngIf="formGroup.controls.capacity.invalid && formGroup.controls.capacity.errors && formGroup.controls.capacity.errors.required"></p>
                        </div>
                      </div>
                      <div class="col s2 m2 l2">
                        <div class="errorZoneSec">
                          <button [disabled]="capacityGroup.updateBtnDisabled" class="actionButton" (click)="capacityGroup.onDelete(formGroup)">Delete</button>
                        </div>
                      </div>
                    </form>
                  </li>
                </ul>
              </div>
              <div class="col s12 m12 l12">
                <div *ngIf="capacityGroup.formsInvalid && capacityGroup.formsError" class="errorZoneSec">
                  <p class="validate">{{capacityGroup.formsError}}</p>
                </div>
                <div class="button-row">
                  <button [disabled]="capacityGroup.formsInvalid || capacityGroup.updateBtnDisabled" md-raised-button class="glbAdminBtnCls1" (click)="capacityGroup.onUpdate()">
                    <img src="./assets/images/saveBtnIcon.png" alt="">UPDATE</button>
                  <button [disabled]="capacityGroup.editBtnDisabled" md-raised-button class="glbAdminBtnCls1" (click)="capacityGroup.onEdit()">
                    <img src="./assets/images/editBtnIcon.png" alt="">EDIT</button>
                  <button [disabled]="capacityGroup.addBtnDisabled" md-raised-button class="glbAdminBtnCls1" (click)="capacityGroup.onAdd()">
                    <i class="material-icons">&#xE145;</i>ADD</button>
                  <button [disabled]="capacityGroup.addBtnDisabled" md-raised-button class="glbAdminBtnCls1" (click)="capacityGroup.onSort()">SORT</button>
                </div>
              </div>
            </md-card-content>
          </md-card>
        </ng-template>
      </div>
    </div>
  </div>
</section>



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-concurrent-exams/adm-manage-concurrent-exams.component.html